<template>
   <div class=".container.is-max-widescreen">
        <div style="margin:20px">
                    <s-button icon="undo" theme="is-warning" label="Annuler" @onclick="$router.go(-1)"/>
         </div>
        <section class="hero">
        <div class="hero-body">
            <div class="container">
               
                <div class="title">
                   <s-l id="searchClubTitle">Recherchez un club</s-l>
                   &nbsp;<s-button icon="info" @onclick="helpSearch=true" theme="is-info is-small" label="" />
                </div>
                <s-info :open="helpSearch" :close="true" @close="helpSearch=false" >
                   <s-l id="searchClubExplain">Vous pouvez rechercher un club</s-l>
                </s-info>
                
                <div style="margin: 30px" v-if="!formSearch" >
                     <label class="label">
                        Vous n'êtes pas connecté et vous vous apprétez à visiter un club en mode invité.<br/>
                    </label>
                    
                    <s-button 
                        @onclick=" connectAnonyme()"
                        icon=""
                        :theme="loadingConnect ? 'is-loading is-primary' : 'is-primary'"
                        label="Poursuivre en mode invité"
                    />
                </div>
                <div v-if="formSearch">
                    <div>
                    <div style="display:inline-block">
                        <input class="input is-primary is-rounded is-medium" 
                            placeholder="Nom du club"
                        type="text" v-model="searchClub" />
                    </div>&nbsp;&nbsp;
                    <div style="display:inline-block">
                    <s-button icon="search" label="" @click="search" theme="is-medium is-primary"/>
                    </div>
                    </div>
                    <div class="error" v-show="searchClub.length<3">
                        La recherche s'effectue à partie de 3 caractères
                    </div>
                
                <div v-if="searchClub.length>2" style="margin:20px">
                    <s-button icon="" theme="is-light is-loading" label="" v-show="loading"/>
                    <div v-for="clubItem in clubs" class="club" v-on:click="goClub(clubItem)">
                       <span class="icon">
                        <i class="fas fa-sign-in-alt"></i>
                        </span> {{clubItem.data().name}}
                    </div>
                    <div v-if="clubs.length==0 && !loading" style="margin: 10px">
                        <b>Aucun resultat</b>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div style="margin-left:50px">
        <s-button 
            @onclick="qrCodeModal=true"
            label="Flasher le code d'un club"
            theme="is-primary"
            afterIcon="qrcode"
            icon="camera" 
            v-if="formSearch"
            />
        </div>
        <s-modal
            :open="qrCodeModal"
            :close="true"
            @close="qrCodeModal=false"
        >
            <div style="height:500px">
            <div class="scanner" v-if="qrCode && qrCodeModal">
                <s-l id="scanQRCode">Présenter le QR code du club :</s-l>
                <qrcode-stream @decode="onDecode"></qrcode-stream>
            </div>
            <div v-show="!qrCode && errorCode" class="QRcodeClub">
                <s-l id="clubNonConnu" >Un QR code a bien été détecté mais il ne correspond pas à un club reconnu</s-l>
                <br/>
                <s-button @onclick="qrCode=true" icon="video" label="Recommencer" theme="is-warning"/>
            </div>
            </div>
        </s-modal>
        </section>
   </div>

                   
</template>
<style  scoped>
    .QRcodeClub {
        margin: 10px;
        
    }
    .scanner {
        height: 250px;
        width: 250px;
        margin-left: auto;
        margin-right: auto;
        font-weight: bolder;
    }
    .title {
        font-size: 20px;
        font-weight: bolder;
    }
    .club {
        margin: 10px;
        padding: 10px;
        color: white;
        font-size: 18px;
        border-radius: 20PX;
        background-color: var(--bluebg);
    }
    .club:hover {
        cursor: pointer;
         background-color: #599429;
    }
</style>
<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import firebase from "firebase/app"
import firebase_api from "@/firebase/firebase_api";
import keys from '@/firebase/keys_firebase';

export default {
    components: {
        QrcodeStream
    },
    data() {
        return {

            formSearch: false,
            searchClub: "",
            clubs: [],
            loading: false,
            loadingConnect: false,
            qrCode: true,
            errorCode: false,
            qrCodeModal: false,
            helpSearch: false
        }
    },
    mounted() {
       if (this.$store.getters.getUser!=null)
            this.formSearch = true;

    },
    watch: {
        searchClub() {
            this.search();
        }
    },
    computed: {
        localhost: {
            get() {
                return window.origin == "http://localhost:8080";
            }
            
        }
    },
    methods: {
        onDecode(qrcode) {
            try {
               
                this.errorCode = false;
                var decoupe = qrcode.split("/");
                var code = decoupe[decoupe.length-1];
                
                firebase_api.api.getDb().collection("club").doc(code).get().then(doc=>{
                    if (doc.exists) {
                        
                        this.$router.push({name: "viewClub", params: {id: code}})
                    }
                    else {
                        this.qrCode = false;
                        this.errorCode = true;
                    }
                })
                .catch(error=>{
                    this.qrCode = false;
                    this.errorCode = true;
                })
            }
            catch {
                 this.qrCode = false;
                 this.errorCode = true;
            }
        },
        goClub(club) {
            this.$router.push({name: "viewClub", params: {id: club.id}})
        },
        search() {
            if (this.searchClub.length>2) {
                this.qrCode = false;
                 this.errorCode = false;
                this.loading = true;
                this.clubs = [];
                firebase_api.api.getDb().collection("club")
                    .where("public","==",true)
                    .orderBy("search")
                    .startAt(this.searchClub.toUpperCase())
                    .endAt(this.searchClub.toUpperCase() + "\uf8ff")
                    .get()
                    .then(doc=>{
                        this.clubs = doc.docs;
                        this.loading = false;
                    })
            }
            else {
                this.qrCode = true;
            }
            
        },
        verifyCaptcha(fct) {
            
            this.$sendRecaptcha( this.$recaptchaLoaded(), this.$recaptcha('search'), result=>{
                console.log(result);
                if (result.data.data.success) {
                    
                    fct();
                }
            })
        },
        connectAnonyme() {
            this.loadingConnect = true;
            this.verifyCaptcha(()=>{
                 firebase.auth().signInWithEmailAndPassword("anonyme@petanque-app.com","anonyme")
                    .then(() => {
                        var user = firebase.auth().currentUser;
                        if (user.displayName!=this.$ANONYME) {
                            user.updateProfile({
                                displayName: this.$ANONYME
                            })
                        }
                        this.formSearch = true;
                        this.loadingConnect = false;
                    })
                    .catch((error) => {
                        var errorCode = error.code;
                        var errorMessage = error.message;
                        // ...
                    });
            })
           
        }
    }
}
</script>